import { useQuery } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import { ApiError, GooglePropertyTypeGSC } from '@pepper/utils/src/types/domain'

const handleFetch = async (companyId: string) => {
  const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/integrations/gsc/properties`
  const response = await axios.get(url)
  return response.data
}

export const useGscList = (companyId: string) => {
  const { data, error, isLoading } = useQuery<
    { data: GooglePropertyTypeGSC[] },
    ApiError
  >({
    queryKey: ['gsc', companyId],
    queryFn: () => handleFetch(companyId),
    enabled: !!companyId,
  })

  return {
    data,
    isLoading,
    error,
  }
}
